module.exports = __webpack_public_path__ + "img/height_armhole.83a85945.png";